import React from 'react'
import {useTranslation} from 'i18n'
import {Paragraph, RoboyuConfused} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {GiftShopRobopetActivationTemplate} from '../ActivationTemplate'

export default function GiftShopRobopetActivationRejected() {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <GiftShopRobopetActivationTemplate
      backgroundColor="white_3"
      robopetImg={
        <RoboyuConfused
          width={convertUnit(161)}
          height={convertUnit(174)}
          colorTheme={colorTheme.name}
        />
      }
      title={translate('giftShop:roboyuActivationRejectedHeader')}
      titleColor="gray_6">
      <Paragraph fontSize="m" fontWeight="regular" color="gray_6">
        {translate('giftShop:roboyuActivationRejectedDescription')}
      </Paragraph>
    </GiftShopRobopetActivationTemplate>
  )
}
